import { useEffect, useContext } from "react";
import context from "../store/context";

import TendersList from "../pages/Tender/TendersList";
import NoPreferance from "../components/cards/NoPreferance";

const MyFeedTelegram = () => {
  const {
    token,
    setTelegramApiPath,
    getPopularCategories,
    getCategories,
    getLanguagesAndRegions,
    getSrc,
    tendersSrc,
  } = useContext(context);

  useEffect(() => {
    setTelegramApiPath("myfeed");
    getCategories("myfeed");
    getLanguagesAndRegions("myfeed");
    getPopularCategories("myfeed");
    if (tendersSrc.length === 0) {
      getSrc();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  window.Telegram?.WebApp?.BackButton?.hide();

  return (
    <TendersList
      noTendersPlaceholder={<NoPreferance />}
      categorySlider={true}
      showSearchSidebar={false}
      filter="myfeed"
    />
  );
};

export default MyFeedTelegram;
